var _defs, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.08em",
    height: "1em",
    viewBox: "0 0 256 238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGjzk6ueva",
    x1: "86.924%",
    x2: "7.63%",
    y1: "94.294%",
    y2: "45.952%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "9%",
    stopColor: "#ffe921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fec700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGb0f7AcFJ",
    x1: "99.538%",
    x2: "23.437%",
    y1: "93.901%",
    y2: "54.033%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "15%",
    stopColor: "#a9a8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "33%",
    stopColor: "#6d97ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "48%",
    stopColor: "#3186ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGxMwz6dYk",
    x1: "87.128%",
    x2: "-.639%",
    y1: "51.518%",
    y2: "93.078%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#0ebc5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    stopColor: "#78c9ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "SVGAiIt3btS",
    d: "M77.303 29.27c22.531-39.026 78.863-39.027 101.394 0l69.373 120.158c22.531 39.027-5.633 87.81-50.698 87.81H58.628c-45.065 0-73.23-48.783-50.698-87.81z"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "SVG6FLXsceq",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#SVGAiIt3btS"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#SVG6FLXsceq)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGjzk6ueva)",
    d: "M341.719 295.937H200.166l-29.293-50.735l70.777-122.589z",
    transform: "translate(-42.87 -58.67)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGb0f7AcFJ)",
    d: "m0 295.916l100.069-173.325v.003l-29.282 50.723h58.57l70.783 122.596l-200.138.001z",
    transform: "translate(-42.87 -58.67)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGxMwz6dYk)",
    d: "m170.881 0l70.781 122.6l-29.286 50.726H70.812z",
    transform: "translate(-42.87 -58.67)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrive);
export default __webpack_public_path__ + "static/media/drive.a65b1d942943d35ddd8c798c1f652b3a.svg";
export { ForwardRef as ReactComponent };